import { Observable } from 'rxjs';

import { Job, PcvizUploadConfig, Pipeline, ResultPage } from '@mirage-projects/cw-models';

import { JobFilter } from '../models/filters/job-filter';

export abstract class JobService {
    /**
     * Get the job by id
     * @param id Job id
     */
    abstract get(id: string): Observable<Job>;

    /**
     * Filter the jobs
     * @param jobFilter Filter to apply
     */
    abstract filter(jobFilter: JobFilter): Observable<ResultPage<Job>>;

    /**
     * Create and start a job
     * @param pipeline Pipeline to create the job
     */
    abstract createAndStart(pipeline: Pipeline): Observable<Job>;

    /**
     * Start a job
     * @param id Job id
     */
    abstract start(id: string): Observable<Job>;

    /**
     * Cancel a job
     * @param id Job id
     */
    abstract cancel(id: string): Observable<Job>;

    /**
     * Estimate a job
     * @param id Job id
     */
    abstract estimate(id: string): Observable<Job>;

    /**
     * Starts process status checking
     * @param process  Job to check
     * @param config Upload configuration
     */
    abstract startCheckProcessStatus(process: Job, config: PcvizUploadConfig): number;
    /**
     * Stop process status checking
     * @param interval Interval id to stop
     */
    abstract stopCheckProcessStatus(interval: number): void;
}
